export const ITERABLE_URL = process.env.REACT_APP_ITERABLE_URL;
export const ITERABLE_TOKEN = process.env.REACT_APP_ITERABLE_TOKEN;

export const ITERABLE_API_URL = process.env.ITERABLE_API_URL;
export const ITERABLE_CLIENT_SIDE_API_KEY =
  process.env.ITERABLE_CLIENT_SIDE_API_KEY;
